import React from 'react';
import type { Question, Language } from '@nordcrest/shared';

interface TextAreaProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  language: Language;
  error?: string;
}

export function TextArea({ question, value, onChange, language, error }: TextAreaProps) {
  const maxLength = question.validation?.maxLength || 1000;

  return (
    <div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
        maxLength={maxLength}
        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors resize-none ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />
      <div className="flex justify-between mt-2">
        {question.description && !error ? (
          <p className="text-sm text-gray-500">{question.description[language]}</p>
        ) : error ? (
          <p className="text-sm text-red-600">{error}</p>
        ) : (
          <span />
        )}
        <span className="text-sm text-gray-400">
          {value.length}/{maxLength}
        </span>
      </div>
    </div>
  );
}
